export default (theme) => {
  const rc = theme.palette.recentChanges;
  return {
    pill: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      margin: '38px 0 0',
      background: rc.pillBg,
      color: rc.pillText,
      borderRadius: 8,
      padding: '8px 14px',
      fontSize: 12,
      lineHeight: 1.4,
      cursor: 'pointer',
      border: 'none',
      textAlign: 'center',
      textTransform: 'none',
      fontFamily: 'inherit',
    },
    pillIcon: {
      fontSize: 16,
      color: rc.pillText,
      marginRight: 6,
    },
    pillDot: {
      margin: '0 5px',
    },
    paper: {
      width: '100%',
      boxSizing: 'border-box', // no global border-box; the theme's iOS-standalone paddingTop must fit inside height:100%
      background: theme.palette.background.default,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden', // the paper must not become a second scroller
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      padding: '8px 8px',
      flexShrink: 0,
      background: theme.palette.background.default,
    },
    headerTitle: {
      flex: 1,
      textAlign: 'center',
      fontSize: 16,
      fontWeight: 500,
    },
    headerSpacer: {
      visibility: 'hidden',
    },
    list: {
      flex: 1,
      minHeight: 0, // let the flex child shrink so it, not the paper, scrolls
      overflowY: 'auto',
      overscrollBehavior: 'contain',
      WebkitOverflowScrolling: 'touch',
      padding: '4px 0 24px',
    },
    card: {
      background: rc.cardBg,
      borderRadius: 4,
      margin: '8px 16px',
      padding: '10px 12px',
    },
    cardTopRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    },
    sectionTitle: {
      color: rc.sectionTitle,
      fontSize: 13,
    },
    time: {
      color: rc.sectionTitle,
      fontSize: 12,
      whiteSpace: 'nowrap',
      marginLeft: 8,
    },
    valueRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      gap: 8,
    },
    value: {
      flex: 1,
      minWidth: 0,
      color: rc.value,
      fontFamily: 'Poppins, Open Sans',
      fontSize: 12,
      fontWeight: '500',
      whiteSpace: 'pre-wrap',
      '& > *': { marginTop: 8 },
    },
    subRow: {
      color: rc.value,
      fontSize: 12,
    },
    subLabel: {
      fontFamily: 'Open Sans, Poppins',
      fontSize: 11,
      fontWeight: '400',
    },
    cl: {
      color: rc.added,
    },
    typeRow: {
      display: 'flex',
      alignItems: 'center',
      gap: 4,
    },
    typeLabel: {
      fontSize: 11,
      fontStyle: 'italic',
    },
    added: { color: rc.added },
    removed: { color: rc.removed },
    edited: { color: rc.edited },
  };
};
